<div class="ad-footer">
  <ad-section-footer-default [option]="option"></ad-section-footer-default>
</div>
